import React, { useState,useEffect } from "react";
import { BrowserRouter, Routes ,Route} from "react-router-dom";
import Sharedlayout
  from "./components/shareLyout";
import Main from "./components/main";
import Profile from './components/subCom/profile'
import Product from "./components/subCom/product";
import Services from "./components/subCom/services";
// import Market from "./components/market";

function App() {
  
  return (
    <>
      <BrowserRouter>
      <Routes>
        <Route path="/" element={<Sharedlayout/>}>
            <Route index element={<Main />} /> 
            <Route path="/profile" element={<Profile/>}/>
            <Route path="/products" element={<Product/>}/>
            <Route path="/services" element={<Services/>}/>
            {/* <Route path="/market" element={<Market/>}/> */}
        </Route>
    </Routes>

    </BrowserRouter>
   
      
       
    </>
  );
}

export default App;
